import "core-js/modules/es6.function.name";
import _classCallCheck from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _get from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/get";
import _inherits from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/model/operation/markeroperation
 */
import Operation from "./operation";
import Range from "../range";
/**
 * @extends module:engine/model/operation/operation~Operation
 */

var MarkerOperation =
/*#__PURE__*/
function (_Operation) {
  _inherits(MarkerOperation, _Operation);

  /**
   * @param {String} name Marker name.
   * @param {module:engine/model/range~Range} oldRange Marker range before the change.
   * @param {module:engine/model/range~Range} newRange Marker range after the change.
   * @param {module:engine/model/markercollection~MarkerCollection} markers Marker collection on which change should be executed.
   * @param {Boolean} affectsData Specifies whether the marker operation affects the data produced by the data pipeline
   * (is persisted in the editor's data).
   * @param {Number|null} baseVersion Document {@link module:engine/model/document~Document#version} on which operation
   * can be applied or `null` if the operation operates on detached (non-document) tree.
   */
  function MarkerOperation(name, oldRange, newRange, markers, affectsData, baseVersion) {
    var _this;

    _classCallCheck(this, MarkerOperation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MarkerOperation).call(this, baseVersion));
    /**
     * Marker name.
     *
     * @readonly
     * @member {String}
     */

    _this.name = name;
    /**
     * Marker range before the change.
     *
     * @readonly
     * @member {module:engine/model/range~Range}
     */

    _this.oldRange = oldRange ? oldRange.clone() : null;
    /**
     * Marker range after the change.
     *
     * @readonly
     * @member {module:engine/model/range~Range}
     */

    _this.newRange = newRange ? newRange.clone() : null;
    /**
     * Specifies whether the marker operation affects the data produced by the data pipeline
     * (is persisted in the editor's data).
     *
     * @readonly
     * @member {Boolean}
     */

    _this.affectsData = affectsData;
    /**
     * Marker collection on which change should be executed.
     *
     * @private
     * @member {module:engine/model/markercollection~MarkerCollection}
     */

    _this._markers = markers;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(MarkerOperation, [{
    key: "clone",

    /**
     * Creates and returns an operation that has the same parameters as this operation.
     *
     * @returns {module:engine/model/operation/markeroperation~MarkerOperation} Clone of this operation.
     */
    value: function clone() {
      return new MarkerOperation(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
    }
    /**
     * See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
     *
     * @returns {module:engine/model/operation/markeroperation~MarkerOperation}
     */

  }, {
    key: "getReversed",
    value: function getReversed() {
      return new MarkerOperation(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_execute",
    value: function _execute() {
      var type = this.newRange ? '_set' : '_remove';

      this._markers[type](this.name, this.newRange, true, this.affectsData);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = _get(_getPrototypeOf(MarkerOperation.prototype), "toJSON", this).call(this);

      if (this.oldRange) {
        json.oldRange = this.oldRange.toJSON();
      }

      if (this.newRange) {
        json.newRange = this.newRange.toJSON();
      }

      delete json._markers;
      return json;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "type",
    get: function get() {
      return 'marker';
    }
  }], [{
    key: "fromJSON",

    /**
     * Creates `MarkerOperation` object from deserialized object, i.e. from parsed JSON string.
     *
     * @param {Object} json Deserialized JSON object.
     * @param {module:engine/model/document~Document} document Document on which this operation will be applied.
     * @returns {module:engine/model/operation/markeroperation~MarkerOperation}
     */
    value: function fromJSON(json, document) {
      return new MarkerOperation(json.name, json.oldRange ? Range.fromJSON(json.oldRange, document) : null, json.newRange ? Range.fromJSON(json.newRange, document) : null, document.model.markers, json.affectsData, json.baseVersion);
    }
  }, {
    key: "className",
    get: function get() {
      return 'MarkerOperation';
    }
  }]);

  return MarkerOperation;
}(Operation);

export { MarkerOperation as default };